import React from 'react';
import GuidedPackageBuilder from '../components/PackageBuilder/GuidedPackageBuilder';

const CreatePackagePage: React.FC = () => {
  return <GuidedPackageBuilder />;
};

export default CreatePackagePage;
